import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
    side_menu_container: {
        backgroundColor: `${theme.palette.secondary.light}`,
        boxSizing: 'border-box',
        height: '100%',
        width: '250px',
        display: 'flex',
        flexDirection: 'column',
        zIndex: 1
    },
    menu_items_container: {
        marginTop: '8px',
        overflowY: 'auto',
        overflowX: 'hidden',
        paddingBottom: 26,
        boxSizing: "border-box",
        '&::-webkit-scrollbar': {
            width: '6px',
        },
        '&::-webkit-scrollbar-track': {
            backgroundColor: theme.palette.secondary.dark,
            borderRadius: '3px',
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: theme.palette.primary.main,
            borderRadius: '3px',
            '&:hover': {
                backgroundColor: theme.palette.primary.light,
            },
        },
    },
    main_tools_container: {
        display: 'flex',
        flexWrap: 'wrap'
    },
    menu_item_container: {
        flexDirection: 'column',
        display: 'flex',
        textDecoration: 'none',
        boxSizing: 'border-box',
    },
    menu_item_title: {
        display: 'flex',
        justifyContent: 'flex-start',
        boxSizing: 'border-box',
        alignItems: 'center',
        color: theme.palette.grey[300],
        fontSize: '16px',
        padding: '8px 14px',
        minHeight: '40px',
        "&:hover": {
            backgroundColor: theme.palette.primary.light,
            color: theme.palette.secondary.light,
            cursor: 'pointer',
        },
        "& svg": {
            fontSize: '20px',
            marginRight: '16px',
            flexShrink: 0
        },
    },
    title_with_children: {
        width: '100%',
        backgroundColor: theme.palette.secondary.dark,
        borderRadius: 0,
        color: theme.palette.common.white,
        minHeight: '44px',
        padding: '10px 14px',
        "&:hover": {
            backgroundColor: theme.palette.primary.light,
            color: theme.palette.secondary.light,
            cursor: 'pointer'
        },
    },
    title_label_with_children: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        gap: '8px',
        "& > div:first-child": {
            flex: 1,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        },
        "& > svg": {
            flexShrink: 0
        }
    },
    label_container: {
        paddingLeft: '26px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    },
    menu_item_children: {
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: theme.palette.secondary.main,
        paddingTop: '4px',
        paddingBottom: '4px'
    },
    title_with_children_active: {
        fontWeight: 800,
        color: theme.palette.primary.main
    },
    active: {
        borderRight: '6px solid',
        boxSizing: 'border-box',
        color: theme.palette.primary.main,
        fontWeight: 800
    },
    main_action_container: {
        display: 'flex',
        height: '50px',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '3px',
        boxSizing: 'border-box',
        flex: '0 0 auto'
    },
    user_info_container: {
        height: '60px',
        backgroundColor: theme.palette.grey["100"],
        padding: '8px',
    }
}));

export {useStyles}
